import React from 'react';
import Icon from '../../../components/AppIcon';

const CompletionOverview = ({ playData, onPlaySelect, selectedPlay }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'on-track':
        return 'bg-success/10 border-success text-success';
      case 'at-risk':
        return 'bg-warning/10 border-warning text-warning';
      case 'critical':
        return 'bg-error/10 border-error text-error';
      default:
        return 'bg-muted/10 border-border text-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'on-track':
        return 'CheckCircle';
      case 'at-risk':
        return 'AlertCircle';
      case 'critical':
        return 'XCircle';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-card-foreground">Play Completion Status</h2>
        <button
          onClick={() => onPlaySelect('all')}
          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
            selectedPlay === 'all' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
        >
          View All
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {playData?.map((play, index) => (
          <div
            key={index}
            onClick={() => onPlaySelect(play?.playTitle)}
            className={`border-2 rounded-lg p-4 cursor-pointer transition-all hover:shadow-md ${
              selectedPlay === play?.playTitle
                ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/50'
            }`}
          >
            <div className="flex items-start justify-between mb-3">
              <h3 className="font-semibold text-card-foreground text-lg">{play?.playTitle}</h3>
              <div className={`px-2 py-1 rounded-full border ${getStatusColor(play?.status)}`}>
                <Icon name={getStatusIcon(play?.status)} size={16} />
              </div>
            </div>

            <div className="mb-3">
              <div className="flex items-center justify-between text-sm mb-1">
                <span className="text-muted-foreground">Completion</span>
                <span className="font-semibold text-card-foreground">{play?.completionRate}%</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2.5">
                <div
                  className={`h-2.5 rounded-full transition-all ${
                    play?.status === 'on-track' ?'bg-success'
                      : play?.status === 'at-risk' ?'bg-warning' :'bg-error'
                  }`}
                  style={{ width: `${play?.completionRate}%` }}
                ></div>
              </div>
            </div>

            <div className="flex items-center justify-between text-sm">
              <div>
                <p className="text-muted-foreground">Missing Files</p>
                <p className="font-semibold text-card-foreground">{play?.missingCount}</p>
              </div>
              <div className="text-right">
                <p className="text-muted-foreground">Total Lines</p>
                <p className="font-semibold text-card-foreground">{play?.totalLines}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompletionOverview;